import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonCriteriaService } from 'src/app/services/common/common-criteria.service';
import { CommonSummaryService } from 'src/app/services/common/common-summary.service';
import { NotesViewModalComponent } from './notes-view-modal/notes-view-modal.component';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { serviceConstants } from 'src/app/constants/service.constants';
import { CommonService } from 'src/app/services/common.service';
import { FilePreviewComponent } from '../document-summary/file-preview/file-preview.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit {

  operations;
  loperations;
  rowData;
  module: string;
  appid: string;
  permission: string = "";

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public route: ActivatedRoute,
    private criteriaService: CommonCriteriaService,
    private commonService: CommonService,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal
    ) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        this.module = params['module'];
        //this.appid = params['id'];
      }      
    });
    this.appid =this.commonService.appId;
    this.permission = "";
    var lper = this.commonService.getPagePermission("IST17");
    if (lper != null && lper) {
      this.permission = lper.toLowerCase();
    }

    this.setOperations();
    this.setSummary("");

    //this.criteriaService.getNotesCriteria().subscribe(criteria=>{
    //  this.operations = criteria.operations.map(operation=>{
    //    return { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' };
    //  });

    //  this.setSummary("");
    //});
  }

  setOperations() {

    this.loperations = [];
   
    if (this.permission !== 'view' && this.permission !== '') {
      this.loperations.push({
        "name": "Add Notes",
        "id": "add"
      });
    }

    this.operations = this.loperations.map(operation => {
      //return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: operation.disabled } : { name: operation.name, callback: this[operation.id], self: this }
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    }); 
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  add(){
    let modalRef = this['self'].modalService.open(NotesViewModalComponent, {
      backdrop: false,
      keyboard: false,

      windowClass:'modal-lg right modal-right',
      animation: true,
      
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: null, appid: this['self'].appid, module: this['self'].module }
    }
    modalRef.result.then(result=>{
      this['self'].setSummary("");
    })
  }

  setSummary(filter: string) {
    let strfilter = "-1";
    if (filter !== "")
      strfilter = filter;
    this.summaryService.getNotes(strfilter, this.appid).subscribe(summary => {
      this.rowData = summary
    });
  }

  downloadFile(ID) {
    let url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + ID;
    window.open(url);
  }
  ViewFile(fileID,fileName)
  {
    this.commonService.previewFile(fileID,fileName,"med");
      // let modalRef = this.modalService.show(FilePreviewComponent, {
      //   backdrop: false,
      //   keyboard: false,
      //   ignoreBackdropClick: true,
      //   class:'modal-llg modal-full-height modal-right',
      //   animated: true,
      //   data: {          
      //     content: { FileID: fileID, Type: "med", FileName: fileName }
      //   }
      // });
    }
  
}
